import { render, staticRenderFns } from "./VerifyingCard.vue?vue&type=template&id=58dd8a62&scoped=true"
import script from "./VerifyingCard.vue?vue&type=script&lang=js"
export * from "./VerifyingCard.vue?vue&type=script&lang=js"
import style0 from "./VerifyingCard.vue?vue&type=style&index=0&id=58dd8a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd8a62",
  null
  
)

export default component.exports